<template>
  <div id="firebaseui-auth-container">
  </div>
</template>

<script>
var firebase = require('firebase');
var firebaseui = require('firebaseui');
import 'firebaseui/dist/firebaseui.css'
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'SignIn',
  components: {
  },
  data() {
    return {
      auth: this.$root.$data.auth,
    }
  },
  methods: {
    startSignIn() {
      const uiConfig = {
        signInSuccessUrl: '/persons',
        signInOptions: [
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            // signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD
          }
        ],
        // Other config options...
      };

      if(firebaseui.auth.AuthUI.getInstance()) {
        const ui = firebaseui.auth.AuthUI.getInstance()
        ui.start('#firebaseui-auth-container', uiConfig)
      } else {
        const ui = new firebaseui.auth.AuthUI(this.auth)
        ui.start('#firebaseui-auth-container', uiConfig)
      }
    }
  },
  mounted() {
    this.startSignIn();
  },
}
</script>
